/**
 * API · resolver info básica de users por ID.
 *
 * Wrap del RPC `core.get_users_basic_info`. SECURITY DEFINER en server
 * — cualquier authenticated puede pedir display_name + avatar de cualquier
 * compañero del workspace.
 */
import { supabase } from '@/lib/supabase';

export interface UserBasicInfo {
  user_id: string;
  email: string;
  display_name: string;
  avatar_url: string | null;
}

export async function getUsersBasicInfo(userIds: string[]): Promise<UserBasicInfo[]> {
  if (userIds.length === 0) return [];
  const { data, error } = await (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    supabase.schema('core' as any) as any
  ).rpc('get_users_basic_info', { p_user_ids: userIds });
  if (error) throw error;
  return (data ?? []) as UserBasicInfo[];
}
